import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ACCOUNTS: MijnRoute = {
    path: 'rekeningen',
    navigationEvent: 'toZelfRegelenRekeningen',
    regex: /^\/zelf-regelen\/rekeningen$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/rekeningen'
};
